import { render, staticRenderFns } from "./productProperty.vue?vue&type=template&id=7316ca80"
import script from "./productProperty.vue?vue&type=script&lang=js"
export * from "./productProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports